import { SelectFieldOption_Values, ValueType } from "../../../Definitions";

/* eslint-disable */
export enum UndefinedOptions {
  undefined = "undefined",
  nan = "NaN",
  null = "null"
}
/* eslint-enable */

export type SelectOptions = {
  feedcurveOptions: SelectFieldOption_Values[];
  groupOptions: SelectFieldOption_Values[];
  systemOptions: SelectFieldOption_Values[];
  milestoneOptions: ValueType[];
  locationOptions: SelectFieldOption_Values[];
  sectionOptions: ValueType[];
  animalOptions: ValueType[];
  allSectionOptions: SelectFieldOption_Values[];
  milestoneOptionsFromFeedcurve: SelectFieldOption_Values[] | undefined;
}

export { useFeedcurveOptions } from "./useFeedcurveOptions"
export { useGroupOptions } from "./useGroupOptions"
export { useMilestoneOptions } from "./useMilestoneOptions"
export { useSystemOptions } from "./useSystemOptions"
export { useAnimalOptions } from "./useAnimalOptions"
export { useSectionOptions } from "./useSectionOptions"